import _ from 'lodash'
import moment from 'moment-mini'
import { RadioGroup, RadioButton } from '../radio'
import { ModeTypes } from './constants'
import { Button } from '../button'
import KPressOnTrigger from '../../core/utils/KPressOnTrigger'

export default {
  name: 'KCalendarHeader',
  props: {
    // 可切换的模式数组：day, week, month, year
    modes: {
      type: Array,
      default() {
        return ['day', 'week', 'month', 'year']
      },
    },
    // 初始模式
    mode: {
      type: String,
      default: 'month',
    },
    // 日期值
    value: {
      type: moment,
      // null
      default() {
        return null
      },
    },
  },
  data() {
    return {
      innerMode: null,
    }
  },
  computed: {
    date() {
      return this.value.format('YYYY年M月')
    },
  },
  watch: {
    mode: {
      immediate: true,
      handler(value) {
        this.innerMode = value
      },
    },
  },
  created() {
  },
  mounted() {
  },
  methods: {
    renderButton(prev, referenceValueKey) {
      const handler = () => {
        this.$emit(`click-${prev ? 'prev' : 'next'}`, referenceValueKey)
      }

      const events = {
        ...KPressOnTrigger(handler),
      }

      const data = {
        on: events,
      }

      return (
        <Button
          {...data}
          type="light"
          circle={true}
          plain={true}
          icon={prev ? 'chevron-left' : 'chevron-right'}
        >
        </Button>
      )
    },
    renderButtonSkeleton(prev) {
      return (
        <Button
          circle={true}
          plain={true}
          disabled={true}
          icon={prev ? 'chevron-left' : 'chevron-right'}
        >
        </Button>
      )
    },
  },
  render() {
    return (
      <div class="km-calendar__header">
        <div class="km-calendar__header--left">
        </div>

        <div class="km-calendar__header-date">
          {this.date}
        </div>

        <div class="km-calendar__header--right">
          <div class="is-pad"></div>
          <RadioGroup
            vModel={this.innerMode}
            checkedTheme="filled"
          >
            {
              _.map(this.modes, mode => {
                const modeMeta = ModeTypes[mode]
                if (modeMeta) {
                  return (
                    <RadioButton
                      value={mode}
                    >
                      {modeMeta.label}
                    </RadioButton>
                  )
                }
              })
            }
          </RadioGroup>
        </div>
      </div>
    )
  },
}
